import { RootState } from '../store';

export const getAlertState = (state: RootState) => state.alert;
